import { replaceDocLinks, getHelpUrl } from './utils';

export { replaceDocLinks, getHelpUrl };
